import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListActiveMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_2452_2276)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2452_2276",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 33,
			height: 32,
			children: /* @__PURE__ */ _jsx("rect", {
				x: .5,
				width: 32,
				height: 32,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2452_2276)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.2693 12.077V10.077H27.8333V12.077H10.2693ZM10.2693 17V15H27.8333V17H10.2693ZM10.2693 21.923V19.923H27.8333V21.923H10.2693ZM6.24366 12.154C5.93855 12.154 5.68278 12.0496 5.47633 11.8407C5.26989 11.6318 5.16666 11.3729 5.16666 11.064C5.16666 10.7627 5.26989 10.51 5.47633 10.306C5.68278 10.102 5.93855 10 6.24366 10C6.54878 10 6.80455 10.102 7.011 10.306C7.21744 10.51 7.32066 10.7627 7.32066 11.064C7.32066 11.3729 7.21744 11.6318 7.011 11.8407C6.80455 12.0496 6.54878 12.154 6.24366 12.154ZM6.24366 17.064C5.93855 17.064 5.68278 16.962 5.47633 16.758C5.26989 16.5542 5.16666 16.3016 5.16666 16C5.16666 15.682 5.26989 15.4209 5.47633 15.2167C5.68278 15.0124 5.93855 14.9103 6.24366 14.9103C6.54878 14.9103 6.80455 15.0124 7.011 15.2167C7.21744 15.4209 7.32066 15.682 7.32066 16C7.32066 16.3016 7.21744 16.5542 7.011 16.758C6.80455 16.962 6.54878 17.064 6.24366 17.064ZM6.24366 22C5.93855 22 5.68278 21.8956 5.47633 21.6867C5.26989 21.4778 5.16666 21.219 5.16666 20.9103C5.16666 20.6088 5.26989 20.356 5.47633 20.152C5.68278 19.948 5.93855 19.846 6.24366 19.846C6.54878 19.846 6.80455 19.948 7.011 20.152C7.21744 20.356 7.32066 20.6088 7.32066 20.9103C7.32066 21.219 7.21744 21.4778 7.011 21.6867C6.80455 21.8956 6.54878 22 6.24366 22Z",
				fill: "white"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_2452_2276",
		x: .5,
		y: 0,
		width: 33,
		height: 33,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1,
				dy: 1
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.112809 0 0 0 0 0.417748 0 0 0 0 0.518555 0 0 0 1 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_2452_2276"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_2452_2276",
				result: "shape"
			})
		]
	}) })]
});
export default SvgListActiveMobile;
